import Congratulate from "@/assets/icons/congratulate.svg?react";
import { cn, formatNumber } from "@/shared/utils";
import { Trans, useTranslation } from "react-i18next";

interface GreatResultProps {
  taskAwards: number | string;
  className?: string;
}

const GreatResult = ({ taskAwards, className }: GreatResultProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        "outline-none text-white bg-white/08 py-3 px-3 rounded-xl text-xs leading-130 flex items-center gap-2 tracking-wide font-normal",
        className
      )}
    >
      <Congratulate className="shrink-0" />
      <div>
        <span className="font-bold mr-1">{t("great_result")}</span>
        <Trans
          i18nKey="you_have_fulfilled_tasks"
          values={{ amount: formatNumber(taskAwards) }}
          components={{
            bold: <span className="font-bold text-orange-100 tracking-wide" />,
          }}
        />
      </div>
    </div>
  );
};

export default GreatResult;
